import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class AudioTopic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        const listItm = (item, index) => {
            return (
                <div key={item.title} className={styles.listItem} style={{ marginRight: index === 4 ? 0 : 20 }}>
                    <a href={item.url} className={styles.fl}>
                        <img src={item.thumbnail} alt={item.title} />
                    </a>
                    <a href={item.url} className={styles.fr} title={item.title}>
                        <p>{item.title}</p>
                    </a>
                </div>
            );
        };

        return (
            <div className={styles.audioTopic}>
                <div className={styles.title}>
                    <h3>精品有声</h3>
                </div>
                <div className={styles.list}>
                    {content &&
                        content.length &&
                        content.map((item, index) => {
                            return listItm(item, index);
                        })}
                </div>
            </div>
        );
    }
}

export default errorBoundary(AudioTopic);
